import { Link } from 'react-router-dom';
import { LencanaLogo } from './HeaderLanding';
import Ikon from './publik/Ikon';

/*
 * Kaki halaman publik sesuai Figma. Kontak hanya surel resmi ditpb3 dan dua
 * alamat kantor (keputusan pengguna 5 Nov 2026; nomor telepon & surel gmail lama
 * dibuang). "Internal" adalah pintu masuk aplikasi untuk pegawai (/masuk).
 */
const TAUTAN = [
    { label: 'Beranda', ke: '/' },
    { label: 'Informasi', ke: '/informasi/merkuri' },
    { label: 'Berita & Artikel', ke: '/berita' },
    { label: 'Dokumen & Peraturan', ke: '/arsip' },
    { label: 'FAQ', ke: '/faq' },
];

export default function FooterLanding() {
    return (
        <footer className="bg-g-600 font-body">
            <div className="mx-auto max-w-[1440px] px-4 pb-7 pt-14 sm:px-8 lg:px-20">
                <div className="grid gap-10 md:grid-cols-[1fr_auto] lg:grid-cols-[450px_1fr_334px] lg:gap-0">
                    <div className="flex flex-col gap-[18px]">
                        <LencanaLogo />
                        <p className="text-[23px] font-semibold text-white">Direktorat Pengelolaan B3</p>
                        <p className="text-sm leading-relaxed text-pb-kaki-teks">
                            Kementerian Lingkungan Hidup /<br />
                            Badan Pengendali Lingkungan Hidup
                        </p>
                    </div>

                    <nav aria-label="Jelajahi" className="flex flex-col gap-[18px]">
                        <p className="text-sm font-semibold text-white">Jelajahi</p>
                        <ul className="flex flex-col gap-[18px]">
                            {TAUTAN.map((t) => (
                                <li key={t.label}>
                                    <Link to={t.ke} className="text-[13px] text-pb-kaki-teks hover:text-white hover:underline">
                                        {t.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <address className="flex flex-col gap-4 not-italic text-sm text-pb-kaki-teks md:col-span-2 lg:col-span-1 lg:pt-9">
                        <a href="mailto:ditpb3@kemenlh.go.id" className="flex items-start gap-3 hover:text-white hover:underline">
                            <Ikon nama="surel" className="mt-0.5 size-4 shrink-0 text-white" />
                            ditpb3@kemenlh.go.id
                        </a>
                        <p className="flex items-start gap-3 leading-relaxed">
                            <Ikon nama="lokasi" className="mt-0.5 size-4 shrink-0 text-white" />
                            Plaza Kuningan, Jl. H. R. Rasuna Said, Kota Jakarta Selatan, Jakarta 12940
                        </p>
                        <p className="flex items-start gap-3 leading-relaxed">
                            <Ikon nama="lokasi" className="mt-0.5 size-4 shrink-0 text-white" />
                            Jl. DI. Panjaitan No.Kav. 24, Kota Jakarta Timur, Jakarta 13410
                        </p>
                    </address>
                </div>

                <div className="mt-12 flex flex-col gap-3 border-t border-pb-hutan-garis pt-6 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-xs text-pb-kaki-teks">
                        Copyright © {new Date().getFullYear()} Kementerian Lingkungan Hidup - All rights Reserved
                    </p>
                    <Link to="/masuk" className="text-xl leading-5 text-[#9f9797] hover:text-white">
                        Internal
                    </Link>
                </div>
            </div>
        </footer>
    );
}
